export default "__VITE_ASSET__BrzDA85Y__"